import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { CouponState } from "./coupon.state";
import { getCoupons, getCouponProducts } from "./coupon.thunk";
import { CouponsResponse, CouponProductsResponse } from "./coupon.types";

const initialState: CouponState = {
  data: null,
  status: "idle",
  error: null,
  couponProducts: {},
};

export const couponSlice = createSlice({
  name: "coupon",
  initialState,
  reducers: {
    /**
     * Reset all coupon state
     */
    resetCoupons: (state) => {
      state.data = null;
      state.status = "idle";
      state.error = null;
      state.couponProducts = {};
    },
    
    /**
     * Reset products for a specific coupon
     */
    resetCouponProducts: (state, action: PayloadAction<number | string>) => {
      delete state.couponProducts[String(action.payload)];
    },
  },
  extraReducers: (build) => {
    // ==================== GET COUPONS ====================
    build
      .addCase(getCoupons.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(
        getCoupons.fulfilled,
        (state, action: PayloadAction<CouponsResponse>) => {
          state.status = "success";
          state.data = action.payload.data.coupons;
        },
      )
      .addCase(
        getCoupons.rejected,
        (state, action: PayloadAction<string | undefined>) => {
          state.status = "error";
          state.error = action.payload ?? "Kuponlar yüklenirken bir hata oluştu.";
        },
      )

      // ==================== GET COUPON PRODUCTS ====================
      .addCase(getCouponProducts.pending, (state, action) => {
        const key = String(action.meta.arg.couponId);
        if (!state.couponProducts[key]) {
          state.couponProducts[key] = {
            coupon: null,
            products: [],
            pagination: null,
            status: "loading",
            error: null,
          };
        } else {
          state.couponProducts[key].status = "loading";
          state.couponProducts[key].error = null;
        }
      })
      .addCase(
        getCouponProducts.fulfilled,
        (state, action: PayloadAction<CouponProductsResponse & { couponId: number | string }>) => {
          const key = String(action.payload.couponId);
          const { data } = action.payload;
          const currentPage = data.pagination.current_page;

          state.couponProducts[key] = {
            coupon: data.coupon,
            products:
              currentPage === 1
                ? data.items
                : [
                    ...(state.couponProducts[key]?.products || []),
                    ...data.items,
                  ],
            pagination: data.pagination,
            status: "success",
            error: null,
          };
        },
      )
      .addCase(getCouponProducts.rejected, (state, action) => {
        const key = String(action.meta.arg.couponId);
        if (state.couponProducts[key]) {
          state.couponProducts[key].status = "error";
          state.couponProducts[key].error =
            action.payload ?? "Ürünler yüklenirken bir hata oluştu.";
        }
      });
  },
});

export const { resetCoupons, resetCouponProducts } = couponSlice.actions;
export default couponSlice.reducer;